import { Pipe, PipeTransform } from '@angular/core';
import { isNumber } from 'lodash';

@Pipe({
	standalone: true,
	name: 'arrondiPlusProche'
})
export class ArrondiPlusProchePipe implements PipeTransform {

	transform(value: any, decimales = 0): any {
		// Si la valeur n'est pas un nombre, on renvoie une chaîne de caractères vide
		if (!isNumber(value)) {
			return '';
		}
		if (decimales > 0) {
			const puissanceDecimales = Math.pow(10, Math.floor(decimales));
			return Math.round(value * puissanceDecimales) / puissanceDecimales;
		}
		else {
			return Math.round(value);
		}
	}

}
